import { Element } from "@craftjs/core";
import Container from "components/general/Container";
import Section from "components/general/Section";
import { Box, Image } from "components/ui";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";
import defaultImage from "../../../assets/media-default.png";
export const PageCardTop = ({ children, ...props }: any) => {
	let isMobile = useIsMobile();

	if (isMobile) {
		return <Box minHeight={"auto"}>{children}</Box>;
	}
	return (
		<Box
			{...props}
			className="text-only"
			style={{
				borderBottom: "1px solid #eee",
				display: "flex",
				flexDirection: "column",
				alignItems: "flex-start",
				marginBlock: "auto",
			}}
		>
			{children}
		</Box>
	);
};

export const PageCardBottom = ({ children, ...props }: any) => {
	return (
		<Box style={{ lineHeight: 24 }} {...props}>
			{children}
		</Box>
	);
};

export const PageMediaPanel = ({ background, padding = 20, isInverted, imageUrl, imageName, variant }: any) => {
	const isMobile = useIsMobile();
	imageUrl = imageUrl + "?width=600&quality=75&format=webp";

	if (isMobile) {
		return (
			<Container sx={{ height: "auto", flex: 0, paddingHorizontal: 12 }}>
				<Box
					style={{
						flexDirection: isInverted ? "column-reverse" : "column",
						minHeight: 540,
						borderRadius: 12,
						height: "auto",
						overflow: "hidden",
						display: "flex",
					}}
					marginTop={"auto"}
				>
					<Box style={{ paddingHorizontal: 24, paddingVertical: 48, backgroundColor: "#DFF6F6", flexDirection: "column" }}>
						<Element canvas id="text" is={PageCardTop} data-cy="card-top" />

						<Element canvas id="buttons" is={PageCardBottom} data-cy="card-bottom" />
					</Box>
					<Box minHeight={300} mb={24} minWidth={"50%"} width={"$full"}>
						{/* <Image alt={imageName ? imageName : "default"} source={imageUrl ? imageUrl : defaultImage} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> */}
					</Box>
				</Box>
			</Container>
		);
	}
	if (variant === "tight") {
		return (
			<Container>
				<Section bg="$basicwhite" paddingVertical={24}>
					<Box
						style={{
							flexDirection: isInverted ? "row-reverse" : "row",
							borderRadius: 12,
							height: "100%",
							overflow: "hidden",
						}}
						marginTop={"auto"}
					>
						<Box style={{ padding: 64, flex: 2, backgroundColor: "#DFF6F6", flexDirection: "column" }}>
							<Element canvas id="text" is={PageCardTop} data-cy="card-top" />

							<Element canvas id="buttons" is={PageCardBottom} data-cy="card-bottom" />
						</Box>
						<Box flex={1} minWidth={"20%"} width={"$full"}>
							<Image alt={imageName ? imageName : "default"} source={imageUrl ? imageUrl : defaultImage} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
						</Box>
					</Box>
				</Section>
			</Container>
		);
	}
	return (
		<Container>
			<Box
				style={{
					flexDirection: isInverted ? "row-reverse" : "row",
					minHeight: 540,
					borderRadius: 12,
					height: "100%",
					overflow: "hidden",
				}}
				marginTop={"auto"}
			>
				<Box style={{ padding: 64, flex: 1, backgroundColor: "#DFF6F6", flexDirection: "column" }}>
					<Element canvas id="text" is={PageCardTop} data-cy="card-top" />

					<Element canvas id="buttons" is={PageCardBottom} data-cy="card-bottom" />
				</Box>
				<Box flex={1} minWidth={"50%"} width={"$full"}>
					{/* <Image alt={imageName ? imageName : "default"} source={imageUrl ? `${imageUrl}?width=400&quality=75&format=webp` : defaultImage} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> */}
				</Box>
			</Box>
		</Container>
	);
};
export const PageMediaPanelDefaultProps = {
	image: defaultImage,
	background: "#ffffff",
	isInverted: false,
};
